import { FormStatusEnum } from '../types';

type ApproverType = 'quality' | 'other' | 'reviewer' | 'mergedApprovers';

export function computeRequiredApproverSelections({
  formStatus,
  approverType,
  qualityApprovalRequired,
  allCurrentApproversCount,
  currentApprovalUsersCount,
}: {
  formStatus: string;
  approverType: ApproverType;
  qualityApprovalRequired: boolean | undefined;
  allCurrentApproversCount: number;
  currentApprovalUsersCount: number;
}): number | undefined {
  if (formStatus !== FormStatusEnum.For_Approval || approverType === 'reviewer') {
    return undefined;
  }
  if (!qualityApprovalRequired) {
    // quality_approval_required=false: quality not mandatory, but at least 1 approver
    // (quality or other) must remain.
    const otherTypeApproverCount = allCurrentApproversCount - currentApprovalUsersCount;
    return otherTypeApproverCount === 0 ? 1 : undefined;
  }
  return approverType === 'quality' ? 1 : undefined;
}

export function computeHasNoPendingApproversLeft({
  removedApproversCount,
  addedApproversCount,
  pendingCurrentApproversCount,
  hasCurrentApprovers,
  formStatus,
  pendingOtherTypeApproversCount,
}: {
  removedApproversCount: number;
  addedApproversCount: number;
  pendingCurrentApproversCount: number;
  hasCurrentApprovers: boolean;
  formStatus: string;
  pendingOtherTypeApproversCount: number;
}): boolean {
  const approverCountChecks =
    removedApproversCount === pendingCurrentApproversCount && addedApproversCount === 0 && removedApproversCount > 0;

  if (!hasCurrentApprovers || formStatus !== FormStatusEnum.For_Approval || !approverCountChecks) {
    return false;
  }

  // Only warn when there are truly no pending approvers left across all types.
  if (pendingOtherTypeApproversCount > 0) {
    return false;
  }

  return true;
}
